import { childProphylaxisTreatmentPurposeIds } from 'src/config/constants'
import { useTreatmentPurpose } from './useTreatmentPurpose'

export const useIsChildProphylaxis = () => {
  const treatmentPurposeId = useTreatmentPurpose()

  return { isChildProphylaxis: isChildProphylaxis(treatmentPurposeId || '') }
}

export const isChildProphylaxis = (treatmentPurposeId: string) =>
  childProphylaxisTreatmentPurposeIds.includes(treatmentPurposeId)
